<template>
  <div class="section section_white section_no-padding-top subscribe-section">
    <div class="max-width">
      <div class="subscribe-section__grid">
        <div class="subscribe-section__about">
          <h2 class="subscribe-section__title">Be the First to Know</h2>
          <div class="subscribe-section__note">Get early access to our newest Shopify themes, feature releases, and updates, plus practical how-to guides to help you get more from your store — directly to your inbox.</div>

          <SubformView :theme="theme" :id="id"/>
        </div>
        <div class="subscribe-section__img">
          <img loading="lazy" src="@/assets/imgs/subscribe-dark.webp" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .subscribe-section {
    &__grid {
      display:flex;
      align-items:center;
      gap:1rem;
      padding:4rem 1rem 4rem 4rem;
      border-radius:12px;
      background:var(--color-main);
      color:#fff;

      @include md {
        flex-direction:column-reverse;
        gap:1rem;
        padding:1.5rem;
      }
    }

    &__about {
      max-width:450px;
      width:100%;
      flex:none;

      @include md {
        max-width:100%;
      }
    }

    &__title {
      font-weight: 900;
      font-size: 2.5rem;
      line-height: 1.2;
      letter-spacing: -0.03em;
      margin:0 0 1rem;

      @include sm {
        font-size:2rem;
      }
    }

    &__note {
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.5;
      letter-spacing: -0.01em;
      margin:0 0 1.5rem;
      opacity:.7;

      @include sm {
        font-size:.875rem;
      }
    }

    .subscribe-form {

    }

    &__img {
      flex:auto;
    }
  }
</style>

<script setup>
import SubformView from "@/components/SubformView.vue";

const props = defineProps({
  theme: {
    type: String,
    default: ''
  },
  id: {
    type: Number,
    default: 0
  }
})
</script>
